<bb-badge-counter-ui
  [count]="136"
  [maxCount]="99"
  color="danger"
></bb-badge-counter-ui>
